import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  // Struktureret data for Kontakt (ContactPage)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Kontakt CM Skruefundament ApS",
    "description": "Kontakt CM Skruefundament ApS for et uforpligtende tilbud på dit næste fundament. Vi står klar til at hjælpe dig i hele Danmark.",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "CM Skruefundament ApS",
      "telephone": "+4526796139",
      "email": "cs@cmskruefundament.dk",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Skolevænget 14",
        "addressLocality": "Horsens",
        "postalCode": "8700",
        "addressCountry": "DK"
      }
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Kontakt os | CM Skruefundament ApS</title>
        <meta name="description" content="Kontakt CM Skruefundament ApS for et uforpligtende tilbud på dit næste fundament. Vi står klar til at hjælpe dig i hele Danmark." />
        <link rel="canonical" href="https://cmskruefundament.dk/kontakt" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cmskruefundament.dk/kontakt" />
        <meta property="og:title" content="Kontakt os | CM Skruefundament ApS" />
        <meta property="og:description" content="Kontakt CM Skruefundament ApS for et uforpligtende tilbud på dit næste fundament. Vi står klar til at hjælpe dig i hele Danmark." />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/06c9940a-d5a6-4016-a4ca-e876b6f16b3e/1579e6f7-9ff1-4e95-aba1-981ac1255ac4.jpg" />
        <meta property="og:locale" content="da_DK" />
        <meta property="og:site_name" content="CM Skruefundament ApS" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://cmskruefundament.dk/kontakt" />
        <meta name="twitter:title" content="Kontakt os | CM Skruefundament ApS" />
        <meta name="twitter:description" content="Kontakt CM Skruefundament ApS for et uforpligtende tilbud på dit næste fundament. Vi står klar til at hjælpe dig i hele Danmark." />
        <meta name="twitter:image" content="https://assets.auxodev.dk/assets/06c9940a-d5a6-4016-a4ca-e876b6f16b3e/1579e6f7-9ff1-4e95-aba1-981ac1255ac4.jpg" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className="bg-slate-900 py-24 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.3em] mb-6 block text-slate-400">Kontakt</span>
          <h1 className="text-[1.6rem] md:text-[2rem] min-[992px]:text-[3rem] font-black uppercase leading-tight mb-8">
            Lad os tage en snak
          </h1>
          <p className="text-xl text-slate-300 max-w-2xl leading-relaxed">
            Har du spørgsmål til et projekt, eller ønsker du et uforpligtende tilbud på skruefundering? 
            Udfyld formularen herunder, eller kontakt os direkte via telefon eller mail.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="text-[1.4rem] md:text-[1.6rem] min-[992px]:text-[2.4rem] font-bold uppercase tracking-tight mb-12">Kontaktinformation</h2>
              
              <div className="space-y-10 text-[1rem]">
                <div className="flex gap-6">
                    <div>
                    <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-2">Virksomhed</h3>
                    <p className="font-bold uppercase">CM Skruefundament ApS</p>
                    <p className="text-slate-600">CVR nr. 46330080</p>
                  </div>
                </div>

                <div className="flex gap-6">
                  <div>
                    <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-2">Adresse</h3>
                    <p className="font-bold uppercase">Skolevænget 14</p>
                    <p className="text-slate-600">8700 Horsens</p>
                  </div>
                </div>

                <div className="flex gap-6">
                  <div>
                    <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-2">Telefon</h3>
                    <a href="tel:+4526796139" className="font-bold uppercase hover:text-slate-600 transition-colors">
                      26 79 61 39
                    </a>
                  </div>
                </div>

                <div className="flex gap-6">
                  <div>
                    <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-2">Email</h3>
                    <a href="mailto:cs@cmskruefundament.dk" className="font-bold uppercase hover:text-slate-600 transition-colors">
                      cs@cmskruefundament.dk
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
